var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SkillsEdit", {
    attrs: {
      value: _vm.value,
      "none-text": "Es ist keine Anwendung von spezieller Software nötig",
      "self-assessment-placeholder": "- Mindesterfahrung auswählen -",
      "meta-skill-property": "skillSoftwareSpecial",
      "keyword-placeholder": "Software, Programme eintragen...",
      "keyword-placeholder-further": "Weitere Software eintragen...",
      type: "job-profile"
    },
    on: {
      validChange: function($event) {
        return _vm.$emit("validChange", $event)
      },
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }